
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash-es";
import moment from "moment";

import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselect.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";

import { Manager } from "@/generated/graphql";

import ManagerRadioButtonOptions from "@/entities/scheduler/ManagerRadioButtonOptions";;
import RadioOption from "@/entities/RadioOption";
import managerViewFiltersTemplate from "@/data/filtersTemplates/scheduler/managerViewFIltersTemplate";
import SchedulerFilters from "@/entities/scheduler/additionalFiltersInterfaces/SchedulerFilters";
import DateRange from "@/entities/scheduler/DateRange";
import CompanyScheduler from "@/views/scheduler/CompanyScheduler.vue";
import FormDateRangePicker from "../../form/FormDateRangePicker.vue";
import UiButton from "@/components/button/ui-button.vue";
import CustomButton from "@/components/new/buttons/CustomButton.vue"
import SelectButton from "@/components/new/buttons/SelectButton.vue"
import schedulerViewFiltersTemplate from "@/data/filtersTemplates/scheduler/schedulerViewFiltersTamplate";
@Component({
    components: {
        ManagersMultiselect,
        FormGroup,
        UserLocationsMultiselect,
        RadioButtonGroup,
        ProfileCountrySelect,
        RegionInput,
        UserCityMultiselect,
        CompanyScheduler,
        FormDateRangePicker,
        UiButton,
        CustomButton,
        SelectButton
    },
})
export default class AddionalFilterCard extends Vue {
    @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;

    filterFields: SchedulerFilters = cloneDeep(schedulerViewFiltersTemplate);
    managerProjects: Manager[] = [];
    rangeStart: Date = new Date();
    rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();


    projectCriterias: any = [
        'Criteria 1',
        'Criteria 2',
        'Criteria 3',
    ];
    projectStatuses: any = [
        'Active',
        'In Progress',
        'Completed',
    ];

    projectName: string = "";



    created(): void {
        this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
    }


    selectedFilters: any[] = [

    ]

    @Watch('selectedFilters')
    handlePropToWatchChange(): void {
        this.$emit("filtersChanged", {
            countries: this.countriesNames ? this.countriesNames : [],
            states: this.statesNames ? this.statesNames : [],
            cities: this.citiesNames ? this.citiesNames : [],
            criterias: this.criterias ? this.criterias : [],
            projectNames: this.projectNames ? this.projectNames : [],
            projectStatuses: this.getProjectStatuses ? this.getProjectStatuses : [],
        })
    }

    @Watch("shouldClearFilters")
    handleClearFilters(value: boolean): void {
        if (value === true) {
            this.clearFilters();
            this.$emit("filtersReset");
        }
    }

    @Watch("numberOfAppliedFilters", { immediate: true })
    appliedFiltersNumberChanged() {
        this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
    }

    @Watch("dateRange")
    handleDateRange() {
        this.$emit("rangeStart", this.rangeStart)
        this.$emit("rangeEnd", this.rangeEnd)
    }

    // @Watch("propToWatch")
    // handlePropToWatchChange(): void {
    //     this.$emit("filtersChanged", {
    //         countries: this.countriesNames,
    //         states: this.statesNames,
    //         cities: this.citiesNames,
    //         criterias:this.criterias,
    //         projectNames:this.projectNames,
    //         projectStatuses:this.getProjectStatuses,
    //     })
    // }

    get numberOfAppliedFilters(): any {
        const appliedFiltersQuantity = {
            countries: this.filterFields.countries.length ? 1 : 0,
            states: this.filterFields.states.length ? 1 : 0,
            cities: this.filterFields.cities.length ? 1 : 0,
        }

        return Object.values(appliedFiltersQuantity)
            .reduce((prevValue, curValue) => {
                return prevValue + curValue;
            }, 0);
    }

    get countriesNames(): any[] {
        //get countries names from selected filters
        var countries = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "Country") {
                countries.push(filter.value)
            }
        });
        return countries
    }

    //create function to filter items from selected filters with key



    get statesNames(): any[] {
        var states = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "Region") {
                return filter.value
            }
        });
        return states
    }

    get citiesNames(): any[] {
        var cities = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "City") {
                return filter.value
            }
        });
        return cities
    }
    get criterias(): any[] {
        var criterias = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "Project Criteria") {
                return filter.value
            }
        });
        return criterias
    }
    get projectNames(): any[] {
        var projectNames = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "Project Name") {
                return filter.value
            }
        });
        return projectNames
    }
    get getProjectStatuses(): any[] {
        var projectStatuses = []
        this.selectedFilters.forEach((filter) => {
            if (filter.type == "Project Status") {
                return filter.value
            }
        });
        return projectStatuses
    }

    get propToWatch(): string {
        return JSON.stringify([
            this.countriesNames,
            this.statesNames,
            this.citiesNames,
            this.criterias,
            this.projectNames,
            this.getProjectStatuses,
        ]);
    }

    get dateRange(): DateRange {
        return {
            startDate: this.rangeStart,
            endDate: this.rangeEnd,
        }
    }

    handleDateRangeChange(date: DateRange) {
        this.rangeStart = date.startDate;
        this.rangeEnd = date.endDate;
        this.addFilter("Date Range", `${moment(this.rangeStart).format("MM/DD/YYYY")} - ${moment(this.rangeEnd).format("MM/DD/YYYY")}`)
    }


    clearFilters(): void {
        this.filterFields = cloneDeep(managerViewFiltersTemplate);
    }

    closeModal(): void {
        this.$emit('close')
    }

    //create function to remove filter from selected filters
    removeFilter(index: number): void {
        this.selectedFilters.splice(index, 1)
    }

    //create function to add filter to selected filters
    addFilter(type, value): void {
        this.selectedFilters.push({
            type: type,
            value: value,
        })
    }

    selectCountry(country: any): void {
        this.addFilter("Country", country[0].name)
    }
    selectCity(city: any): void {
        this.addFilter("City", city[0].name)
    }
    selectRegion(region: any): void {
        this.addFilter("Region", region[0].name)
    }
    selectProjectCriteria(criteria: any): void {
        this.addFilter("Project Criteria", criteria)
    }

    selectProjectName(): void {
        this.addFilter("Project Name", this.projectName)
    }

    selectProjectStatus(status: any): void {
        this.addFilter("Project Status", status)
    }

    clearAllFilters(): void {
        this.selectedFilters = []
        this.clearFilters()
    }
}
